import { render, staticRenderFns } from "./moreRooms.vue?vue&type=template&id=5b4d1c5c&scoped=true&"
import script from "./moreRooms.vue?vue&type=script&lang=js&"
export * from "./moreRooms.vue?vue&type=script&lang=js&"
import style0 from "./moreRooms.vue?vue&type=style&index=0&id=5b4d1c5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d1c5c",
  null
  
)

export default component.exports